export default __webpack_public_path__ + "static/media/Operations_Manager_Role.9a1b3c85.svg";